import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode, lazy } from "react";
import { Suspense } from "react";
import('react-dom/client').then(ReactDOMClient => {
    const App = lazy(() => import("./app"));
    const root = ReactDOMClient.createRoot(document.getElementById('root'));
    root.render(_jsx(StrictMode, { children: _jsx(Suspense, { children: _jsx(App, {}) }) }));
});
